module.exports = __webpack_public_path__ + "static/finish-25bbed5247109699f05a3ea89d41ac42.jpg";